import { render, staticRenderFns } from "./AccountsReceivableHistory.vue?vue&type=template&id=5f226692&scoped=true"
import script from "./AccountsReceivableHistory.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableHistory.vue?vue&type=script&lang=js"
import style0 from "./AccountsReceivableHistory.vue?vue&type=style&index=0&id=5f226692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f226692",
  null
  
)

export default component.exports